import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const RedirectRoute = ({ defaultLoc }: { defaultLoc: string }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const loc = searchParams.get('loc') || defaultLoc;

  useEffect(() => {
    window.location.href = loc.startsWith('/') && !loc.startsWith('/#/') ? `/#${loc}` : loc;
  }, [loc, defaultLoc]);

  return null;
};

export default RedirectRoute;
